{
  "search-result-for": "Search result for \"{{searchStr}}\"",
  "Search results": "Search results"
}
